import {TranslateService} from "@ngx-translate/core";
import {ArianeElement, ArianeStore, ModalService, TagConstantes} from "@digicerba/common";
import {AsiFileService} from "@asi-ngtools/lib";
import {ResourceMultimediaPipe} from "@utils/image/resource.multimedia.pipe";
import {
  TagCodeLibelleDto,
  CreateRessourceMultimediaDto,
  GestionArticleDetailDto,
  IGestionCatalogueWebServiceClient,
  MultilingualDto,
  MultilingualLibelleDto,
  SaveArticleDto
} from "@resources/resources";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import * as lodash from "lodash";

@Component({
  selector: 'enregistrement-article-component',
  templateUrl: './enregistrement.articles.component.html',
  host: { 'class': 'page' }
})
export class EnregistrementArticleComponent {

  articleForm: FormGroup;
  article: GestionArticleDetailDto;
  imageSrc: string;
  autorisations: TagCodeLibelleDto[];
  categories: MultilingualLibelleDto[];

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService, private modalService: ModalService, private activatedRoute: ActivatedRoute, private router: Router,
    private fb: FormBuilder, private gestionCatalogueWebServiceClient: IGestionCatalogueWebServiceClient, private fileUtils: AsiFileService,
    private resourcePipe: ResourceMultimediaPipe) {
  }

  private initArianne(article: GestionArticleDetailDto) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.administration",
        route: "/administration"
      },
      {
        libelle: "ARIANNE.ADMINISTRATION.articles",
        route: "/administration/articles"
      },
      {
        libelle: this.translateService.instant("ARIANNE.ADMINISTRATION.article", { identifiant: (article != null ? article.reference : "") }),
        route: "/administration/enregistrement/article/" + (article != null ? article.id : "")
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.article = this.activatedRoute.snapshot.data['article'];
    this.categories = this.activatedRoute.snapshot.data['categories'];
    this.autorisations = this.activatedRoute.snapshot.data['autorisations'];

    this.initArianne(this.article);

    if (this.article) {
      let presentes = [];
      this.autorisations.forEach(element => {
        if (lodash.indexOf(this.article.autorisations, element.code) != -1) {
          presentes.push(element);
        }
      });

      let categorieIndex = lodash.findIndex(this.categories, this.article.categorie);
      let categorie = null;
      if (categorieIndex != -1) {
        categorie = this.categories[categorieIndex];
      }

      this.articleForm = this.fb.group({
        autorisation: [presentes],
        categorie: categorie,
        reference: [this.article.reference, Validators.required],
        libelle_produit: [this.article.libelle.fr, Validators.required],
        conditionnement: this.article.conditionnement ? this.article.conditionnement.fr : null,
        libelle_quantite: this.article.quantiteMessage ? this.article.quantiteMessage.fr : null,
        quota: [this.article.maxQuantite, Validators.required],
        facteur: [this.article.multiplicateur, Validators.required],
        particularite: this.article.particularite ? this.article.particularite.fr : null,
        ordre: [this.article.ordre, Validators.required],
        tagAnalyse: this.article.tagAnalyse,
        texte_desactivation: this.article.desactivationMessage ? this.article.desactivationMessage.fr : null,
        actif: this.article.actif,
        photo: [null, Validators.required]
      });
      this.imageSrc = this.resourcePipe.transform(this.article.imageId);
    }
    else {
      this.articleForm = this.fb.group({
        autorisation: null,
        categorie: null,
        reference: [null, Validators.required],
        libelle_produit: [null, Validators.required],
        conditionnement: null,
        libelle_quantite: null,
        quota: [null, Validators.required],
        facteur: [null, Validators.required],
        particularite: null,
        ordre: [null, Validators.required],
        tagAnalyse: null,
        texte_desactivation: null,
        actif: true,
        photo: [null, Validators.required]
      });
    }
  }

  goarticles() {
    this.router.navigate(['cerba/administration/articles']);
  }

  submit() {
    if (!this.articleForm.valid) {
      return;
    }
    let newArticle = new SaveArticleDto;

    newArticle.autorisations = (this.articleForm.value.autorisation || []).map(dto => dto.code);
    newArticle.idCategorie = this.articleForm.value.categorie ? this.articleForm.value.categorie.id : null;
    newArticle.reference = this.articleForm.value.reference;

    let label = new MultilingualDto;
    label.fr = this.articleForm.value.libelle_produit;
    let labelConditionnement = new MultilingualDto;
    labelConditionnement.fr = this.articleForm.value.conditionnement;
    let labelQuantité = new MultilingualDto;
    labelQuantité.fr = this.articleForm.value.libelle_quantite;
    let labelParticularité = new MultilingualDto;
    labelParticularité.fr = this.articleForm.value.particularite;
    let labelDesactivation = new MultilingualDto;
    labelDesactivation.fr = this.articleForm.value.texte_desactivation;


    newArticle.label = label;
    newArticle.conditionnement = labelConditionnement.fr ? labelConditionnement : null;
    newArticle.quantiteMessage = labelQuantité.fr ? labelQuantité : null;
    newArticle.particularite = labelParticularité.fr ? labelParticularité : null;
    newArticle.desactivationMessage = labelDesactivation.fr ? labelDesactivation : null;
    newArticle.maxQuantite = this.articleForm.value.quota;
    newArticle.multiplicateur = this.articleForm.value.facteur;
    newArticle.order = this.articleForm.value.ordre;
    newArticle.tagAnalyse = this.articleForm.value.tagAnalyse;
    newArticle.actif = this.articleForm.value.actif ? this.articleForm.value.actif : false;

    let photo = new CreateRessourceMultimediaDto;
    let fichier: File = this.articleForm.value.photo;

    this.fileUtils.fileToBase64(fichier).subscribe(result => {
      result = result.substring(result.indexOf(",") + 1);
      photo.content = result;
      photo.name = fichier.name;
      photo.mimeType = fichier.type;
      photo.size = fichier.size;
      newArticle.photo = photo;

      if (this.article) {
        if (this.article.id) {
          this.gestionCatalogueWebServiceClient.updateArticle(this.article.id, newArticle).subscribe(result => {
            let dialog = this.modalService.openInfoDialog("MODAL.ENREGISTREMENT_ARTICLE.title", "MODAL.ENREGISTREMENT_ARTICLE.message",
              "MODAL.ENREGISTREMENT_ARTICLE.confirm");
            dialog.onDialogClose().subscribe(() => {
              this.router.navigate(['cerba/administration/articles']);
            });
          });
          return;
        }
      }
      this.gestionCatalogueWebServiceClient.createArticle(newArticle).subscribe(result => {
        let dialog = this.modalService.openInfoDialog("MODAL.ENREGISTREMENT_ARTICLE.title", "MODAL.ENREGISTREMENT_ARTICLE.message",
          "MODAL.ENREGISTREMENT_ARTICLE.confirm");
        dialog.onDialogClose().subscribe(() => {
          this.router.navigate(['cerba/administration/articles']);
        });
      });
    });
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/administration/articles/enregistrement/enregistrement.articles.component.ts